"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var stepStates = {
  INTERACTIVE: 'interactive',
  PASSED: 'passed'
};

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_stepRef", function (el) {
      var elementRef = _this.props.elementRef;

      if (typeof elementRef === 'function') {
        elementRef(el);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = el;
      }

      _this.contentRef = el;
    });
    return _this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var state = this.props.state;

      if (this.contentRef && prevProps.state !== state) {
        if (state === stepStates.PASSED && typeof this.contentRef.uiPassed === 'function') {
          this.contentRef.uiPassed();
        }

        if (state === stepStates.INTERACTIVE && typeof this.contentRef.uiInteractive === 'function') {
          this.contentRef.uiInteractive();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          state = _this$props.state,
          children = _this$props.children,
          toNextStep = _this$props.toNextStep,
          toPrevStep = _this$props.toPrevStep,
          toStep = _this$props.toStep,
          getModel = _this$props.getModel,
          getActiveStep = _this$props.getActiveStep,
          activeStepIndex = _this$props.activeStepIndex,
          component = _react["default"].Children.only(children);

      return _react["default"].cloneElement(component, {
        ref: this._stepRef,
        isActiveStep: state === stepStates.INTERACTIVE,
        toNextStep: toNextStep,
        toPrevStep: toPrevStep,
        toStep: toStep,
        getModel: getModel,
        getActiveStep: getActiveStep,
        activeStepIndex: activeStepIndex
      });
    }
  }]);
  return _default;
}(_react["default"].Component);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "propTypes", {
  activeStepIndex: _propTypes["default"].number,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  getActiveStep: _propTypes["default"].func,
  toNextStep: _propTypes["default"].func,
  toPrevStep: _propTypes["default"].func,
  toStep: _propTypes["default"].func,
  getModel: _propTypes["default"].func,
  children: _propTypes["default"].element,
  state: _propTypes["default"].oneOf([stepStates.INTERACTIVE, stepStates.PASSED])
});
(0, _defineProperty2["default"])(_default, "displayName", 'Base.Views.Step');